import { Typography } from "@material-tailwind/react";
import { Table } from "../../../../components/table/Table";
import CustomerAdminActions from "./CustomerAdminActions";
import {
  formatCustomerAddress,
  getCustomerEmail,
  getCustomerPhone,
  RecordedDataList
} from "./AdminCustomerDisplay";
import { t } from "../../../../i18n";

export default function AdminCustomersTable({
  customers,
  selectedHead,
  orderDesc,
  onHeadClick,
  onChange,
  onRemove,
  enableRowLinks = true
}: {
  customers: EasyTech.Customer[],
  selectedHead?: string,
  orderDesc?: boolean,
  onHeadClick?: (head: string, orderDesc: boolean) => void,
  onChange?: () => void,
  onRemove?: (customer: EasyTech.Customer) => void,
  enableRowLinks?: boolean
}) {
  const TABLE_HEAD = [
    { label: t("admin:customers.columns.details"), orderKey: onHeadClick ? "name" : null, width: "32%" },
    { label: t("admin:customers.columns.contact"), orderKey: null, width: "24%" },
    { label: t("admin:customers.columns.dataRecorded"), orderKey: null, width: "28%" },
    { label: t("admin:customers.columns.actions"), orderKey: null, width: "16%" }
  ];

  return (
    <Table
      tableHead={TABLE_HEAD}
      emptyTable={(!customers || customers.length === 0) ? t("client:noData") : false}
      selectedHead={selectedHead}
      orderDesc={orderDesc}
      onHeadClick={onHeadClick}
      enableRowLinks={enableRowLinks}
    >
      {customers.map((customer, index) => {
        const isLast = index === customers.length - 1;
        const classes = isLast ? "p-2 align-top" : "p-2 border-b border-blue-gray-50 align-top";
        const customerUrl = `/customers/${customer.id}`;
        const address = formatCustomerAddress(customer.address);

        return (
          <tr
            key={customer.id}
            data-href={enableRowLinks ? customerUrl : undefined}
          >
            <td className={classes}>
              <div className="et-cell-wrap">
                <Typography variant="small" className="font-semibold uppercase text-blue-gray-900">
                  {customer.name}
                </Typography>
                <ul className="mt-1 list-disc pl-4 text-sm text-blue-gray-700">
                  {customer.nip && <li>{customer.nip}</li>}
                  {address && <li>{address}</li>}
                </ul>
              </div>
            </td>
            <td className={classes}>
              <div className="et-cell-wrap flex flex-col gap-0.5">
                <Typography variant="small">{getCustomerEmail(customer)}</Typography>
                <Typography variant="small">{getCustomerPhone(customer)}</Typography>
              </div>
            </td>
            <td className={classes}>
              <RecordedDataList data={customer.recordedData} />
            </td>
            <td className={classes} data-no-link>
              <CustomerAdminActions
                customer={customer}
                onChange={onChange}
                onRemove={onRemove}
              />
            </td>
          </tr>
        );
      })}
    </Table>
  );
}
